import ScanbotSDK from "scanbot-web-sdk/ui";
import { UIConfig } from "scanbot-web-sdk/@types";

export default function startScanner(
	config: UIConfig.BarcodeScannerScreenConfiguration
) {
	const result = ScanbotSDK.UI.createBarcodeScanner(config);
	return result;
}
